export const initState = () => ({
  authors: []
})

export default initState
